import { useTranslation } from 'react-i18next';
import { Price } from '@artosera/ui';
import type { EcritureFigee, MouvementArtiste } from '../../api/comptesArtistes.js';
import { estApiError } from '../../api/errors.js';
import styles from './ComptesArtistes.module.css';

export function messageCompte(erreur: unknown, repli: string): string {
  return estApiError(erreur) ? erreur.message : repli;
}
export function estDepassement(erreur: unknown): boolean {
  return (
    estApiError(erreur) &&
    erreur.status === 409 &&
    (erreur.code === 'comptes_artistes.depassement_solde' ||
      (typeof erreur.details === 'object' &&
        erreur.details !== null &&
        'raison' in erreur.details &&
        erreur.details.raison === 'comptes_artistes.depassement_solde'))
  );
}
export function EcrituresCompte({
  ecritures,
}: {
  ecritures: (MouvementArtiste | EcritureFigee)[];
}) {
  const { t, i18n } = useTranslation(['regie', 'commun']);
  const langue = i18n.language === 'en' ? 'en' : 'fr';
  const piece = (e: MouvementArtiste | EcritureFigee) => {
    if ('piece' in e) return e.piece ?? '—';
    if ('type' in e) return e.source?.avoirId ?? e.source?.factureId ?? e.reference ?? '—';
    return '—';
  };
  return (
    <div className={styles.tableauEnveloppe}>
      <table className={styles.tableau}>
        <caption>{t('regie:comptesArtistes.ecritures')}</caption>
        <thead>
          <tr>
            {['date', 'libelle', 'piece', 'montant'].map((cle) => (
              <th key={cle} scope="col">
                {t(`regie:comptesArtistes.${cle}`)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ecritures.map((e) => (
            <tr key={e.id}>
              <td>{e.date.slice(0, 10)}</td>
              <td>
                {'libelle' in e ? e.libelle : e.motif || t(`regie:comptesArtistes.types.${e.type}`)}
              </td>
              <td>{piece(e)}</td>
              <td>
                <Price cents={e.montantCentimes} lang={langue} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {ecritures.length === 0 && <p>{t('regie:comptesArtistes.aucuneEcriture')}</p>}
    </div>
  );
}
